// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import * as SagaBase from '../../../SagaBase';
import { CallcardCreateArgs } from '../../../SagaBase/Defines/CallcardCreateArgs';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrisisCardCreateArgs_abstract extends CallcardCreateArgs {
  static $t: string = 'SagaBase.Defines.CrisisCardCreateArgs';
  $t: string = 'SagaBase.Defines.CrisisCardCreateArgs';

  public static GetMembers(): string[] {
    return [].concat(CallcardCreateArgs.GetMembers());
  }

  public GetMembers(): string[] {
    return CrisisCardCreateArgs_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
